export const fr = {
  nav: {
    home: "Accueil",
    activities: "Nos Activités",
    sectors: "Vos métiers",
    workflows: "Workflows",
    faq: "FAQ",
    louise: "LouiseTrinitIA",
    contact: "Contact",
    cta: "Démarrer un Projet"
  },
  hero: {
    badge: "Intelligence Architecture Expertise",
    title1: "Votre",
    title2: "Temps",
    title3: "Notre Expertise",
    description: "PEXADIA déploie des systèmes autonomes de haute performance pour racheter votre temps. Déléguez vos taches chronopages pour vous concentrer sur l'essentiel.",
    cta1: "Racheter mes Heures",
    cta2: "Explorer les Systèmes",
    stats: {
      productivity: "Gain de Productivité",
      hours: "Heures Libérées / an",
      infrastructure: "Infrastructure",
      roi: "ROI Opérationnel"
    }
  },
  timeImpact: {
    badge: "Performance Comparée",
    title1: "Le",
    title2: "Delta",
    title3: "Pexadia",
    description: "La mesure mathématique de votre avantage concurrentiel. Ne travaillez plus plus dur, travaillez plus intelligemment.",
    table: {
      indicator: "Indicateur",
      traditional: "Traditionnel",
      pexadia: "Écosystème Pexadia",
      impact: "Impact"
    },
    metrics: [
      {
        indicator: "Gestion des Workflows",
        traditional: "15-20 hours / week",
        pexadia: "15 minutes / week",
        impact: "98%"
      },
      {
        indicator: "Création Visuelle & Contenu",
        traditional: "3-5 days lead time",
        pexadia: "Instantané (On-demand)",
        impact: "x50"
      },
      {
        indicator: "Précision & Erreur Humaine",
        traditional: "12% error rate",
        pexadia: "0.02% (Déterministe)",
        impact: "-99%"
      },
      {
        indicator: "Scalabilité Opérationnelle",
        traditional: "Linear hiring",
        pexadia: "Élasticité Totale ∞",
        impact: "Exponentiel"
      }
    ]
  },
  services: {
    badge: "Solutions Universelles",
    title1: "L'Excellence",
    title2: "Technologique",
    description: "Nos piliers d'expertise pour transformer chaque aspect de votre structure et racheter votre temps.",
    items: [
      {
        title: "Automatisation IA",
        desc: "Libérez votre temps en déléguant les tâches répétitives à nos agents intelligents.",
        features: [
          "Workflows autonomes",
          "Intégration API avancée",
          "Analyse prédictive de données"
        ]
      },
      {
        title: "Création Visuelle",
        desc: "Des visuels époustouflants générés par les meilleurs modèles de diffusion au monde.",
        features: [
          "Branding génératif",
          "Assets publicitaires",
          "Animation vidéo par IA"
        ]
      },
      {
        title: "Développement Web 3.0",
        desc: "Des sites internet modernes, ultra-rapides et nativement dotés de capacités IA.",
        features: [
          "React & Next.js experts",
          "UI/UX Future-proof",
          "Intégration LLM directe"
        ]
      },
      {
        title: "Stratégie & Conseil",
        desc: "Nous vous accompagnons dans la transition technologique de votre entreprise.",
        features: [
          "Audit de processus",
          "Formation IA équipes",
          "Architecture de données"
        ]
      }
    ]
  },
  sectors: {
    badge: "Impact Sectoriel",
    title1: "L'IA pour Vos",
    title2: "Métiers",
    description: "Nous n'appliquons pas de solutions génériques. Nous rachetons votre temps en automatisant le cœur même de votre profession.",
    items: [
      {
        role: "Artisans & BTP",
        gain: "1 150 € / mois",
        task: "DEVIS & FACTURATION",
        detail: "Transformez vos soirées de paperasse en heures facturables. L'IA génère vos devis et métrés en 2 minutes : vous gagnez 12h de production par mois."
      },
      {
        role: "Notaires & Avocats",
        gain: "2 400 € / mois",
        task: "ANALYSE DE DOSSIERS",
        detail: "Divisez par 4 votre temps de lecture juridique. L'analyse automatisée de milliers de pages sécurise vos dossiers et libère du temps pour vos conseils à haute valeur ajoutée."
      },
      {
        role: "Agents Immobiliers",
        gain: "1 850 € / mois",
        task: "MATCHING ACQUÉREURS",
        detail: "Ne laissez plus aucun prospect s'échapper. Qualification automatique et rédaction de fiches multilingues en un clic pour augmenter votre volume de mandats sans effort."
      },
      {
        role: "E-commerçants",
        gain: "3 200 € / mois",
        task: "FICHES & SUPPORT",
        detail: "Réduisez vos frais de support de 80%. Notre IA gère les litiges et les mises à jour de stocks en temps réel, agissant comme une équipe de 3 personnes 24h/24."
      },
      {
        role: "Santé & Cabinets",
        gain: "950 € / mois",
        task: "COMPTES-RENDUS",
        detail: "Supprimez les tâches administratives chronophages. Vos comptes-rendus sont dictés et structurés instantanément, vous permettant de voir 2 patients de plus par jour."
      },
      {
        role: "RH & Recrutement",
        gain: "2 100 € / mois",
        task: "SOURCING & TRI",
        detail: "Réduisez votre coût d'embauche de moitié. Le pré-entretien vidéo par IA et le sourcing prédictif vous permettent de signer les meilleurs talents avant vos concurrents."
      },
      {
        role: "Experts-Comptables",
        gain: "1 600 € / mois",
        task: "SAISIE & AUDIT",
        detail: "Éradiquez l'erreur humaine et la saisie manuelle. L'IA détecte les anomalies fiscales instantanément, transformant votre cabinet en centre d'excellence technologique."
      },
      {
        role: "Hôtellerie",
        gain: "1 300 € / mois",
        task: "CONCIERGERIE IA",
        detail: "Boostez vos réservations directes. La conciergerie IA répond en 12 langues et convertit les demandes en ventes immédiates, sans commission pour les plateformes tierces."
      }
    ],
    notListed: {
      title: "Votre métier n'est pas listé ?",
      description: "Notre expertise est universelle. Nous analysons vos processus critiques et créons l'agent IA capable de les absorber, quel que soit votre domaine.",
      cta: "Audit Métier Personnalisé"
    },
    cta: "Solliciter l'Étude de Cas",
    impact: "GAIN"
  },
  workflows: {
    badge: "Architecture Neurale v3.0",
    title1: "L'Ingénierie du",
    title2: "Succès",
    description: "Nous ne bricolons pas d'outils. Nous bâtissons des infrastructures d'intelligence industrielle rigoureusement orchestrées.",
    ingress: "01 / INGRESS",
    core: "THE NEURAL CORE",
    egress: "03 / EGRESS",
    ingressItems: [
      {
        title: "Omni-Channel Trigger",
        metric: "LATENCY: 1.2MS",
        desc: "Capture de données via API, Webhooks & Scrapers de pointe pour une ingestion continue."
      },
      {
        title: "Identity Verification",
        metric: "SEC_PROTOCOL: TLS 1.3",
        desc: "Validation, authentification et filtrage rigoureux de chaque requête entrante."
      },
      {
        title: "Data Normalization",
        metric: "FORMAT: JSON/PROTOBUF",
        desc: "Uniformisation automatique des flux de données disparates en structures exploitables."
      }
    ],
    coreItem: {
      title: "PEX-ENGINE V4",
      subtitle: "Proprietary Engine",
      desc: "Notre moteur propriétaire orchestre les modèles de langage les plus avancés, gère la mémoire contextuelle à long terme et prend des décisions autonomes.",
      speed: "VITESSE",
      speedValue: "180 t/s",
      confidence: "CONFIANCE",
      confidenceValue: "99.89"
    },
    egressItems: [
      {
        title: "Execution & Delivery",
        metric: "ACTION: AUTO-EXEC",
        desc: "Déclenchement automatique d'actions métier : emails, rapports, ou commandes ERP."
      },
      {
        title: "UI/UX Sync",
        metric: "SYNC: REAL-TIME",
        desc: "Synchronisation instantanée des interfaces utilisateurs pour une expérience réactive."
      },
      {
        title: "ERP Integration",
        metric: "DB_STATUS: COMMITTED",
        desc: "Consolidation des résultats directement dans vos bases de données sécurisées."
      }
    ],
    footer: {
      title1: "Votre infrastructure,",
      title2: "réinventée.",
      description: "Oubliez les intégrations fragiles. Pexadia déploie des systèmes industriels pensés pour la performance brute et la fiabilité absolue.",
      cta: "Auditer mes Processus"
    }
  },
  faq: {
    badge: "Support Client",
    title1: "Questions",
    title2: "Fréquentes",
    description: "Tout ce que vous devez savoir sur nos solutions et notre méthodologie d'ingénierie.",
    items: [
      {
        question: "Comment fonctionne l'automatisation Pexadia ?",
        answer: "Pexadia déploie des systèmes autonomes qui capturent vos données, les traitent via notre moteur IA propriétaire, et exécutent automatiquement vos actions métier. Tout est orchestré sans intervention manuelle."
      },
      {
        question: "Quels types de processus peuvent être automatisés ?",
        answer: "Presque tous : gestion de documents, analyse de données, génération de contenu, synchronisation d'interfaces, intégrations ERP, support client, et bien plus selon votre secteur."
      },
      {
        question: "Combien de temps prend la mise en place ?",
        answer: "L'audit initial prend 24-48h. Le déploiement complet varie selon la complexité, généralement entre 2 à 6 semaines pour une infrastructure complète."
      },
      {
        question: "Quelle est la sécurité de mes données ?",
        answer: "Tier-1 infrastructure avec chiffrement end-to-end, conformité RGPD, et bases de données sécurisées. Vos données ne quittent jamais votre environnement contrôlé."
      }
    ]
  },
  contact: {
    badge: "Initiation de Projet",
    title1: "Parlons de votre",
    title2: "Futur",
    description: "Vous avez un projet innovant ou souhaitez automatiser votre business ? Nos ingénieurs reviennent vers vous sous 24h.",
    emailLabel: "Email Direct",
    locationLabel: "Siège Opérationnel",
    location: "Paris, Dubaï",
    form: {
      name: "Nom complet",
      email: "E-mail pro",
      message: "Détails du projet",
      placeholderName: "Jean Dupont",
      placeholderEmail: "jean@entreprise.fr",
      placeholderMessage: "Comment optimiser votre temps ?",
      cta: "Initialiser la Transmission",
      success: "Transmission Réussie",
      successDesc: "Un expert Pexadia vous contactera sous 24h.",
      another: "Envoyer un autre message"
    }
  },
  louise: {
    badge: "Mannequin IA",
    title: "LouiseTrinitIA",
    description: "Découvrez Louise, notre mannequin IA révolutionnaire. Une création numérique qui repousse les limites de l'intelligence artificielle et de la créativité visuelle.",
    gallery: {
      title: "Galerie Photos"
    },
    comments: {
      title: "Commentaires TikTok"
    }
  },
  footer: {
    description: "Pionniers de l'intelligence artificielle appliquée au business. Nous créons les systèmes autonomes qui définiront le marché de demain.",
    nav: "Navigation",
    legal: "Légal",
    rights: "PEXADIA Intelligence Agency. Tous droits réservés."
  }
};

